(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gabybru-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.gabybruWhatsAppClickReady) return;
    window.gabybruWhatsAppClickReady = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-gabybru-whatsapp]');
      if (!link) return;

      const section = document.getElementById('MainProduct-' + link.dataset.gabybruSection);
      const picker = section?.querySelector('variant-selects, variant-radios');
      let variant = picker?.currentVariant;

      if (!variant && picker) {
        const selectedId = section?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
        const jsonElement = picker.querySelector('script[data-selected-variant], script[type="application/json"]');
        if (jsonElement) {
          try {
            const parsed = JSON.parse(jsonElement.textContent);
            if (Array.isArray(parsed)) {
              variant = parsed.find((item) => String(item.id) === selectedId) || null;
            } else if (parsed?.id && (!selectedId || String(parsed.id) === String(selectedId))) {
              variant = parsed;
            }
          } catch (_) {
            variant = null;
          }
        }
      }

      if (variant) {
        link.dataset.gabybruSku = variant.sku || '';
        link.dataset.gabybruVariant = variant.title || '';
        link.dataset.gabybruPrice = String(variant.price ?? 0);
        link.dataset.gabybruCompareAt = String(variant.compare_at_price ?? 0);
      }

      const model = link.dataset.gabybruProductTitle;
      const cents = variant ? Number(variant.price) : Number(link.dataset.gabybruPrice);
      const compareAtCents = variant
        ? Number(variant.compare_at_price ?? 0)
        : Number(link.dataset.gabybruCompareAt);
      const offer = Number.isFinite(compareAtCents) && compareAtCents > cents;
      const price = Number.isFinite(cents)
        ? new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(cents / 100)
        : '';
      const message = 'Hola, me interesa el modelo ' + model +
        (price ? ', ' + (offer ? 'Precio en oferta' : 'Precio') + ': ' + price + '.' : '.');

      link.href = 'https://wa.me/56934631222?text=' + encodeURIComponent(message);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
